import styled from 'styled-components';
export const AppSearchBar = styled.div `
  font-family: 'Roboto'
  .MuiInputBase-root {
    .MuiInputBase-input {
      width: calc(100% - 32px);
    }
  }
  .MuiInputLabel-root {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    width: calc(100% - 50px);
    text-overflow: ellipsis;
  }
  .clearSearch:hover {
    background-color: rgba(51, 51, 51, 0.08);
  }
  .advanceSearch:hover {
    color: #0d1b33;
    background-color: rgba(51, 51, 51, 0.08);
  }
`;
